var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96667 3.11111C4 3.60556 4.08333 4.08889 4.21667 4.55L3.55 5.21667C3.32222 4.55 3.17778 3.84444 3.12778 3.11111H3.96667ZM9.44444 9.78889C9.91667 9.92222 10.4 10.0056 10.8889 10.0389V10.8667C10.1556 10.8167 9.45 10.6722 8.77778 10.45L9.44444 9.78889ZM4.5 2H2.55556C2.25 2 2 2.25 2 2.55556C2 7.77222 6.22778 12 11.4444 12C11.75 12 12 11.75 12 11.4444V9.50556C12 9.2 11.75 8.95 11.4444 8.95C10.7556 8.95 10.0833 8.83889 9.46111 8.63333C9.40556 8.61111 9.34445 8.60556 9.28889 8.60556C9.14445 8.60556 9.00556 8.66111 8.89444 8.76667L7.67222 9.98889C6.1 9.18333 4.81111 7.9 4.01111 6.32778L5.23333 5.10556C5.38889 4.95 5.43333 4.73333 5.37222 4.53889C5.16667 3.91667 5.05556 3.25 5.05556 2.55556C5.05556 2.25 4.80556 2 4.5 2Z",
    fill: "#9A9CAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3af7dc84b65e513b24d66b3de844b23c.svg";
export { ForwardRef as ReactComponent };